import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'

import auth from './auth'
import orders from './orders'
import backdrop from './backdrop'
import common from './common'
import price from './price'
import assign from './assign'
import uploads from './uploads'
import car from './car'
import spareParts from './spareparts'
import embeddedbooking from './embeddedbooking'
import overview from './overview'

// Language
import {i18nState} from '../language'

const appReducer = combineReducers({
  auth,
  orders,
  backdrop,
  common,
  price,
  i18nState,
  assign,
  uploads,
  car,
  spareParts,
  embeddedbooking,
  routing: routerReducer,
  overview
})

export default function rootReducer (state, action) {
  if (action.type === 'SET_CURRENT_USER') {
    if (typeof action.user.Token === 'undefined') {
      state.assign = undefined
      state.auth = undefined
      state.backdrop = undefined
      state.common = undefined
      state.price = undefined
      state.uploads = undefined
      // Reset orders
      state.orders.orders = []
      state.orders.order = {}
      state.orders.errors = false
      state.orders.filter = state.orders.initialFilter
    }
  }
  return appReducer(state, action)
}



// WEBPACK FOOTER //
// ./src/app/reducers/index.js